import cookieHelper from '@/helpers/cookie/cookie'; 
const cookieBridge = new cookieHelper;

function isLogged() {  
    return !(
        (cookieBridge.getCookie('access_token') == undefined || cookieBridge.getCookie('access_token') == 'undefined' )  
    );
}

export default isLogged; 